'use client';
import CmsPageRenderer from '@/components/CmsPageRenderer';
import { useT } from '@/lib/useT';

export default function AboutPage() {
  const t = useT();
  return (
    <CmsPageRenderer
      slug="about"
      fallback={{
        title: t('about_title'),
        subtitle: t('about_subtitle'),
        sections: [
          {
            id: 'mission',
            title: t('about_mission_title'),
            body: t('about_mission_body'),
          },
          {
            id: 'story',
            title: t('about_story_title'),
            body: t('about_story_body'),
          },
          {
            id: 'what-we-do',
            title: t('about_whatwedo_title'),
            body: t('about_whatwedo_body'),
          },
          {
            id: 'values',
            title: t('about_values_title'),
            body: t('about_values_body'),
          },
          {
            id: 'tech',
            title: t('about_tech_title'),
            body: t('about_tech_body'),
          },
          {
            id: 'team',
            title: t('about_team_title'),
            body: t('about_team_body'),
          },
          {
            id: 'cta',
            title: t('about_cta_title'),
            body: t('about_cta_body'),
          },
        ],
      }}
    />
  );
}
